import { jsx as _jsx } from "react/jsx-runtime";
import { secondDescription } from '../models/secondDescription';
const SecondDescriptionWidget = () => {
    return (_jsx("div", { className: "second-description-widget", children: secondDescription.map((secondDescription) => (_jsx("div", { children: _jsx("p", { children: secondDescription.description }) }, secondDescription.id))) }));
};
export default SecondDescriptionWidget;
